import { AuthenticatedUser } from '@gettactic/api';

export function isHpe(user?: AuthenticatedUser) {
  return ['hpe', 'hpe-test'].includes(user?.organization?.slug ?? '');
}
